import outlineAPI from './outline';
import loginAPI from './login';
import vipAPI from './vip';
import homeAPI from './home';
import pptAPI from './powerpoint';
import fileAPI from './file';
import callbackAPI from './callback';
import secretKey from './secretKey';

export default {
  ...outlineAPI,
  ...loginAPI,
  ...vipAPI,
  ...homeAPI,
  ...pptAPI,
  ...fileAPI,
  ...callbackAPI,
  ...secretKey,
}
